<script>
import formdate from "@/router/views/formcomponet/formdate.vue";
import forminput from "@/router/views/formcomponet/forminput.vue";
import formtextarea from "@/router/views/formcomponet/formtextarea.vue";
import formcheckbox from "@/router/views/formcomponet/formcheckbox.vue";
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import oduyuru from "@/models/oduyuru";
import moment from "moment";
import useVuelidate from "@vuelidate/core";
export default {
  mixins: [Api, Sabit, oduyuru],
  props: ["Id", "AddEdit"],
  data() {
    return {
      v$: useVuelidate(),
      FormData: null,
      ModalOpen: this.AddEdit ? true : false,
    };
  },
  components: {
    forminput,
    formtextarea,
    formcheckbox,
    formdate,
  },
  watch: {
    Id() {
      this.FormData = this.Id;
    },
  },
  methods: {
    onSubmit() {
      this.v$.$touch();
      if (!this.v$.$invalid) {
        this.FormData.KayitTarihi = moment(new Date()).format("YYYY-MM-DD");
        if (this.AddEdit == "Add") {
          this.Post("ODuyuru", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.ODuyuruData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        } else {
          this.Update("ODuyuru", this.FormData).then((res) => {
            if (res) {
              this.FormData = this.ODuyuruData;
              this.$emit("TableUpdate");
              this.ModalOpen = false;
            }
          });
        }
      }
    },
    Get() {},
  },
};
</script>
<template>
  <b-modal
    v-model="ModalOpen"
    id="ODuyuru"
    size="lg"
    :title="
      this.AddEdit == 'Edit'
        ? 'Kayıt Düzenle'
        : 'Yeni Kayıt Ekle'
    "
    title-class="font-18"
    hide-footer
  >
    <Form @submit.prevent="onSubmit" v-if="FormData">  
      
      <forminput
        :FormDataType="FormDataType.Baslik"
        :Value="FormData.Baslik"
        :v="v$.FormData.Baslik"
        @input="FormData.Baslik = $event.target.value"
      />
      <formtextarea
        :FormDataType="FormDataType.Icerik"
        :Value="FormData.Icerik"
        :v="v$.FormData.Icerik"
        @input="FormData.Icerik = $event.target.value"
      />
      <formdate
        :FormDataType="FormDataType.IslemTarihi"
        :Value="FormData.IslemTarihi"
        :v="v$.FormData.IslemTarihi"
        @input="FormData.IslemTarihi = $event.target.value"
      />
      <formcheckbox
        :FormDataType="FormDataType.YeniMi"
        :Value="FormData.YeniMi"
        :v="v$.FormData.YeniMi"
        @input="FormData.YeniMi = $event.target.checked"
      />

      <button class="btn btn-primary" type="submit">
        Kaydet
      </button>
    </Form>
  </b-modal>
</template>
